import moment from 'moment';
import 'moment/locale/es';
moment().local('es');

const useFormatDate = () => {
    const formatDate = (date, format) => moment(date).format(format);
    return { formatDate }
}

export default useFormatDate